import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ButtonToolbar, Col, Row, Button } from "reactstrap";
import { Field, reduxForm } from 'redux-form';
import { Table, TableBody, TableCell, TableHead, TableRow, } from '@mui/material';
import { useState } from "react";
import { useEffect } from "react";
import PndRestApi from "src/utils/pnd/PndRestApi";
import renderSelectField from "src/shared/components/form/Select";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { convertToHoursAndMinutes } from "src/utils/pnd/PndUtilities";
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";


const DutyRoasterUpdation = ({ dataInfo, setIsRedirect }) => {
    const [assignedItems, setAssignedItems] = useState(1);
    const [selectedShifts, setSelectedShifts] = useState({});
    const [isDay, setDay] = useState(null);


    useEffect(() => {
        getAllHubDutyShiftConfig();
        const date = new Date(dataInfo?.roasterDate); // Example date
        const dayOfWeek = date.getDay();

        // Convert the number to the corresponding day
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const dayName = days[dayOfWeek];
        setDay(dayName);
    }, []);


    const getAllHubDutyShiftConfig = async () => {
        let shiftInfoList = [];
        try {

            const response = await PndRestApi.GetAllHubDutyShiftConfigByCustomerIdAndHubId();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.map(item => {
                    shiftInfoList.push({ label: item?.shiftTypesInfo?.shiftName + " (" + convertToHoursAndMinutes(item?.shiftStartTime) + "-" + convertToHoursAndMinutes(item?.shiftEndTime) + ")", value: item?.shiftId });
                })
                setAssignedItems(shiftInfoList);

            } else {
                console.error('Unexpected response status:', response.status);


            }
        } catch (error) {
            console.error('Error fetching data:', error);

        }
    };

    const handleSubmit = async () => {
        try {
            let Obj = {};
            Obj["roasterId"] = dataInfo?.roasterId;
            Obj["shiftId"] = selectedShifts;
            const response = await PndRestApi.UpdateRiderRoasterData(Obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message: ${"Successfully updated the Shift Details"}`,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);

            }
            else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message: ${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };
    const handleShiftChange = (shiftId) => {

        setSelectedShifts(shiftId ? shiftId.value : null)
        // if (applyToAll) {
        //     const newShifts = {};
        //     isNextWeekDates.forEach(date => {
        //         newShifts[date.formattedDate] = shiftId;
        //     });
        //     setSelectedShifts(newShifts);
        // } else {
        //     setSelectedShifts(prevState => ({
        //         ...prevState,
        //         [day]: shiftId,
        //     }));
        //     if (day === isNextWeekDates[0].formattedDate) {
        //         setFirstRowShiftSelected(true);
        //     }
        // }
    };
    return (
        <form className="form form--horizontal" style={{ padding: '0 15px' }}>
            <div className="card__title" style={{ marginBottom: '20px' }}>
                <h5 className="bold-text">Rider Information</h5>
                <p className="subhead" style={{ fontSize: '14px', color: '#2d3748' }}>
                    <strong>{dataInfo?.riderName}</strong>
                </p>
            </div>

            <Row className="form__form-group">
                <Col md={4}>
                    <span className="form__form-group-label" style={{ fontWeight: 600 }}>Roster Date</span>
                </Col>
                <Col md={8}>
                    <p style={{ margin: 0 }}>{dataInfo?.roasterDate} ({isDay})</p>
                </Col>
            </Row>

            {dataInfo?.shiftId && (
                <Row className="form__form-group">
                    <Col md={4}>
                        <span className="form__form-group-label" style={{ fontWeight: 600 }}>Shift Details</span>
                    </Col>
                    <Col md={8}>
                        <Field
                            name="shift"
                            component={renderSelectField}
                            type="text"
                            options={assignedItems}
                            placeholder="Select Shift"
                            onChange={(event) => handleShiftChange(event)}
                        />
                    </Col>
                </Row>
            )}

            <div className="form__button-toolbar wizard__toolbar" style={{ marginTop: '25px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <Button
                    color="primary"
                    className="next"
                    onClick={handleSubmit}
                    style={{
                        backgroundColor: '#32CA73',
                        borderColor: '#32CA73',
                        padding: '8px 25px',
                        fontWeight: 600
                    }}
                >
                    Update Roster
                </Button>
            </div>
        </form>
    );
};

DutyRoasterUpdation.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string.isRequired,
    header: PropTypes.bool,
};

DutyRoasterUpdation.defaultProps = {
    title: "",
    message: "",
    colored: false,
    header: false,
};

const mapStateToProps = (state, data) => {
    // Access riderDutyRoasterDetails prop and use it here
    if (data && data?.dataInfo) {
        return {
            initialValues: {
                shift: { value: data?.dataInfo?.shiftId, label: data?.dataInfo?.shiftName },

            }
        };
    }
};

export default connect(mapStateToProps)(reduxForm({ form: 'DutyRoasterUpdationForm', enableReinitialize: true })(DutyRoasterUpdation))